import type * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetGradeLevelsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetGradeLevelsQuery = { __typename?: 'RootQueryType', gradeLevels?: { __typename?: 'KeysetPageOfGradeLevel', results?: Array<{ __typename?: 'GradeLevel', id: string, gradeLevelType?: string | null }> | null } | null };


export const GetGradeLevelsDocument = gql`
    query GetGradeLevels {
  gradeLevels(sort: {order: ASC, field: PADDED_GRADE_LEVEL_TYPE}) {
    results {
      id
      gradeLevelType
    }
  }
}
    `;

/**
 * __useGetGradeLevelsQuery__
 *
 * To run a query within a React component, call `useGetGradeLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGradeLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGradeLevelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGradeLevelsQuery(baseOptions?: Apollo.QueryHookOptions<GetGradeLevelsQuery, GetGradeLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGradeLevelsQuery, GetGradeLevelsQueryVariables>(GetGradeLevelsDocument, options);
      }
export function useGetGradeLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGradeLevelsQuery, GetGradeLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGradeLevelsQuery, GetGradeLevelsQueryVariables>(GetGradeLevelsDocument, options);
        }
// @ts-ignore
export function useGetGradeLevelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGradeLevelsQuery, GetGradeLevelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGradeLevelsQuery, GetGradeLevelsQueryVariables>;
export function useGetGradeLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGradeLevelsQuery, GetGradeLevelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGradeLevelsQuery | undefined, GetGradeLevelsQueryVariables>;
export function useGetGradeLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGradeLevelsQuery, GetGradeLevelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGradeLevelsQuery, GetGradeLevelsQueryVariables>(GetGradeLevelsDocument, options);
        }
export type GetGradeLevelsQueryHookResult = ReturnType<typeof useGetGradeLevelsQuery>;
export type GetGradeLevelsLazyQueryHookResult = ReturnType<typeof useGetGradeLevelsLazyQuery>;
export type GetGradeLevelsSuspenseQueryHookResult = ReturnType<typeof useGetGradeLevelsSuspenseQuery>;
export type GetGradeLevelsQueryResult = Apollo.QueryResult<GetGradeLevelsQuery, GetGradeLevelsQueryVariables>;